














































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Article from "../../../store/entities/articles/article";
import Editor from "@tinymce/tinymce-vue";
import TinymceInit from "../../../lib/TinymceInit";
import SinglePicture from "../../../components/single-picture.vue";

@Component({
    components: { Editor, SinglePicture }
})
export default class EditArticle extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    article: Article = new Article();
    tinymceInit = TinymceInit;
    created() {}
    get cateList() {
        return this.$store.state.article.cates;
    }
    editorBlur(filedName) {
        (this.$refs.articleForm as any).validateField(filedName)
    }
    save() {
        (this.$refs.articleForm as any).validate(async (valid: boolean) => {
            if (valid) {
                await this.$store.dispatch({
                    type: "article/update",
                    data: this.article
                });
                (this.$refs.articleForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.articleForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.article = Util.extend(
                true,
                {},
                this.$store.state.article.editArticle
            );
        }
    }

    articleRule = {
        title: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("Title")),
                trigger: "blur"
            }
        ],
        body: [
            {
                required: true,
                message: this.L(
                    "FieldIsRequired",
                    undefined,
                    this.L("ArticleBody")
                ),
                trigger: "blur"
            }
        ],
        articleBody: [
            {
                required: true,
                message: this.L(
                    "FieldIsRequired",
                    undefined,
                    this.L("ArticleBody")
                ),
                trigger: "blur"
            }
        ],
        articleCategoryId: [
        {
            required: true,
            message: this.L("FieldIsRequired", undefined, this.L("ArticlesCategories")),
            trigger: "change",
            transform(value) {
                if(value) {
                  return value.toString();
                } else {
                  return value;
                }
            }
        }
    ]
    };
}
